import * as React from 'react';
import { Label } from '@cian/ui-kit';

import { LABEL_BACKGROUNDS, LABEL_COLORS } from './constants';
import { TLabelType } from '../../../../types/specialPromos/specialPromos';

interface IMortgagePromoCardLabelProps {
  text: string;
  type: TLabelType;
}

export const PromoCardLabel: React.FC<IMortgagePromoCardLabelProps> = React.memo(({ text, type }) => {
  return (
    <Label background={LABEL_BACKGROUNDS[type]} color={LABEL_COLORS[type]}>
      {text}
    </Label>
  );
});

PromoCardLabel.displayName = 'PromoCardLabel';
